import { useState } from "react";
import { Heading, Muted } from "@/components/typography";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { settings } from "@/lib/settings";

export function ReviewerNameGate({ onSaved }: { onSaved: () => void }) {
  const [name, setName] = useState("");

  function submit() {
    const trimmed = name.trim();
    if (!trimmed) return;
    settings.setReviewerName(trimmed);
    onSaved();
  }

  return (
    <div className="flex flex-1 items-center justify-center p-6">
      <div className="w-full max-w-sm space-y-4">
        <Heading as="h1" variant="h4">
          Name this reviewer
        </Heading>
        <Muted>Credits approvals on the leaderboard. Cannot be changed later.</Muted>
        <Input
          autoFocus
          value={name}
          onChange={e => setName(e.target.value)}
          onKeyDown={e => e.key === "Enter" && submit()}
          placeholder="e.g. Rina"
        />
        <Button className="w-full" disabled={!name.trim()} onClick={submit}>
          Save
        </Button>
      </div>
    </div>
  );
}
